import axios from '@/axios';

const RESOURCE_NAME = '/needs-startups';

export default {
    getNewAiMatches(id) {
        return axios.get(`${RESOURCE_NAME}/get-new-ai-matches?id=${id}`)
    },

    getStartups(id) {
        return axios.get(`${RESOURCE_NAME}/get-startups?id=${id}`)
    },

    getUnreviewedStartups(id) {
        return axios.get(`${RESOURCE_NAME}/get-unreviewed-startups?id=${id}`)
    },

    getStartupDetails(linkId) {
        return axios.get(`${RESOURCE_NAME}/get-startup-details?link_id=${linkId}`)
    },

    setStartupMatchStatus(id, startupId, matchStatus) {
        return axios.post(`${RESOURCE_NAME}/set-startup-match-status?id=${id}&startup_id=${startupId}`, {matchStatus})
    },

    removeStartupsMatchStatus(id) {
        return axios.post(`${RESOURCE_NAME}/remove-startups-match-status?id=${id}`)
    },
}
